import { useTranslation } from 'react-i18next';
import { supportedLanguages, type SupportedLanguage } from '@/i18n';
import styles from './LanguageSwitcher.module.css';

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage ?? 'es') as SupportedLanguage;

  return (
    <div className={styles.group} role="group" aria-label={t('language.label')}>
      {supportedLanguages.map((lng) => (
        <button
          key={lng}
          type="button"
          className={styles.option}
          aria-pressed={current === lng}
          onClick={() => void i18n.changeLanguage(lng)}
        >
          <span className="visually-hidden">{t(`language.${lng}`)}</span>
          <span aria-hidden>{lng.toUpperCase()}</span>
        </button>
      ))}
    </div>
  );
}
